/**
 * Platform services injected by the SPA at mount time (packages/web/src/app-package.ts).
 * The app package never imports platform internals; it receives them here.
 * Shapes are structural so the platform can pass its own objects directly.
 */
export interface PlatformApi {
  get<T>(path: string): Promise<T>;
  post<T>(path: string, body?: unknown): Promise<T>;
  put<T>(path: string, body?: unknown): Promise<T>;
  delete<T = void>(path: string): Promise<T>;
}

export interface PlatformUser {
  id: string;
  email: string;
  name: string;
  role: string;
  roleKeys: readonly string[];
  attributes: {
    externalId?: string | null;
    masOrgId?: string | null;
    masSiteId?: string | null;
    crewId?: string | null;
    [key: string]: unknown;
  };
}

export interface PlatformAuth {
  user: PlatformUser | null;
  can: (permission: string) => boolean;
}

export interface PlatformWebServices {
  api: PlatformApi;
  useAuth: () => PlatformAuth;
}

let services: PlatformWebServices | null = null;

export function registerPlatform(s: PlatformWebServices): void {
  services = s;
}

export function platform(): PlatformWebServices {
  if (!services) throw new Error('App package used before registerPlatform() was called.');
  return services;
}

/** Convenience: the platform auth hook, typed for app screens. */
export function useAuth(): PlatformAuth {
  return platform().useAuth();
}
